<template>
  <button type="button" class="player-fullscreen-control" @click="toggle">
    <i class="fa" :class="[fullscreen ? 'fa-compress' : 'fa-expand']" aria-hidden="true"></i>
  </button>
</template>

<style lang="scss">
.player-fullscreen-control {
  position: absolute;
  right: 2px;
  top: 2px;
  width: 40px;
  height: 40px;
  background: rgba(0,0,0,0.5);
  border-radius: 50%;
  color: rgba(255,255,255,0.8);
  font-size: 22px;
  border: none;
  z-index: 2147483648;
  cursor: pointer;

  &:focus {
    outline: 0;
  }
}
</style>

<script>
import { isIOSDevice } from '@/utils/device'

const APIs = {
  w3: {
    enabled: 'fullscreenEnabled',
    element: 'fullscreenElement',
    request: 'requestFullscreen',
    exit: 'exitFullscreen',
    onchange: 'fullscreenchange',
    onerror: 'fullscreenerror'
  },
  newWebkit: {
    enabled: 'webkitFullscreenEnabled',
    element: 'webkitFullscreenElement',
    request: 'webkitRequestFullscreen',
    exit: 'webkitExitFullscreen',
    onchange: 'webkitfullscreenchange',
    onerror: 'webkitfullscreenerror'
  },
  oldWebkit: {
    enabled: 'webkitIsFullScreen',
    element: 'webkitCurrentFullScreenElement',
    request: 'webkitRequestFullScreen',
    exit: 'webkitCancelFullScreen',
    onchange: 'webkitfullscreenchange',
    onerror: 'webkitfullscreenerror'
  },
  moz: {
    enabled: 'mozFullScreen',
    element: 'mozFullScreenElement',
    request: 'mozRequestFullScreen',
    exit: 'mozCancelFullScreen',
    onchange: 'mozfullscreenchange',
    onerror: 'mozfullscreenerror'
  },
  ios: {
    enabled: 'webkitFullscreenEnabled',
    element: 'webkitFullscreenElement',
    request: 'webkitEnterFullscreen',
    exit: 'webkitExitFullscreen',
    onchange: 'webkitfullscreenchange',
    onerror: 'webkitfullscreenerror'
  },
  ms: {
    enabled: 'msFullscreenEnabled',
    element: 'msFullscreenElement',
    request: 'msRequestFullscreen',
    exit: 'msExitFullscreen',
    onchange: 'MSFullscreenChange',
    onerror: 'MSFullscreenError'
  }
}

export default {
  props: [
    'video'
  ],

  data () {
    return {
      fullscreen: false
    }
  },

  methods: {
    isFullscreen () {
      return (document[this.api.element] != null || this.video.webkitDisplayingFullscreen)
    },
    toggle () {
      if (this.isFullscreen()) {
        this.video[this.api.exit]()
      } else {
        this.video[this.api.request]()
      }
    }
  },

  mounted () {
    for (let browser in APIs) {
      if (APIs[browser].enabled in document) {
        this.api = APIs[browser]
        break
      }
    }
    if (isIOSDevice()) { // Override APIs on iOS
      this.api = APIs.ios
    }
    document.addEventListener(this.api.onchange, (evt) => {
      this.fullscreen = this.isFullscreen()
    })
  }
}
</script>





// WEBPACK FOOTER //
// FullscreenControl.vue?299b19ac